module.exports = __webpack_public_path__ + "img/CM-KT-CA-CJDR-Lifestyle.3c5d9d52.jpeg";